import { render, staticRenderFns } from "./BlocoInforDadosGestao.vue?vue&type=template&id=69c3d66a&scoped=true&lang=pug"
import script from "./BlocoInforDadosGestao.vue?vue&type=script&lang=js"
export * from "./BlocoInforDadosGestao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInforDadosGestao.vue?vue&type=style&index=0&id=69c3d66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c3d66a",
  null
  
)

export default component.exports